module.exports = require("npm:baguettebox.js@1.8.2/dist/baguetteBox.min.js");